import { useEffect } from 'react'
import { Navigate, useNavigate } from 'react-router'
import { useNFCSState } from 'modules/nfcs/hooks/useNFCSState'
import { useFormConfirmed } from 'shared/hooks/useFormConfirmed'

import { Text } from 'shared/ui/common/Text'
import { NarrowWrapper } from 'shared/ui/layout/NarrowWrapper'
import { SuccessData } from 'modules/pools/ui/FormBorrow'
import { FormBorrowBlocked } from 'modules/pools/ui/FormBorrowBlocked'
import { PageLoader } from 'shared/ui/layout/PageLoader'
import { RouteBorrowSentRedirect } from './RouteBorrowSentRedirect'

import { createRoute } from 'modules/router/utils/createRoute'
import { useNFCSModal } from 'modules/nfcs/ui/NFCSModal/useNFCSModal'
import { markets as marketsLink } from 'modules/router/links'
import { NFCSMintProgress } from 'modules/nfcs/ui/NFCSMintProgress'
import { NFCSRetrieving } from 'modules/nfcs/ui/NFCSRetrieving'

import s from './RouteBorrow.module.scss'

function RouteBorrow() {
  const { nfcsStatus, risk } = useNFCSState()
  const modalNFCS = useNFCSModal()
  const navigate = useNavigate()
  const { pathname, isConfirmed, successData } = useFormConfirmed<SuccessData>()

  useEffect(() => {
    if (
      risk === null &&
      (nfcsStatus === 'not-generated' || nfcsStatus === 'failed')
    ) {
      modalNFCS.open({
        onClose: () => {
          navigate(marketsLink)
          modalNFCS.close()
        },
      })
    }
  }, [modalNFCS, navigate, risk, nfcsStatus])

  if (nfcsStatus === 'server-error') {
    return (
      <Text size={16} weight={600} isUppercased>
        Server error occurred while receiving the credit score
      </Text>
    )
  }

  if (nfcsStatus === 'rate-limit') {
    return (
      <div className={s.mintProgress}>
        <NFCSRetrieving />
      </div>
    )
  }

  if (nfcsStatus === 'generating') {
    return (
      <div className={s.mintProgress}>
        <NFCSMintProgress title="Mint NFCS" />
      </div>
    )
  }

  if (risk === null) {
    return <PageLoader />
  }

  if (isConfirmed) {
    if (!successData) return <Navigate replace to={pathname} />
    return <RouteBorrowSentRedirect successData={successData} />
  }

  return (
    // <NarrowWrapper>
    //   <FormBorrow nfcs={nfcs} risk={risk} onSuccess={confirmForm} />
    // </NarrowWrapper>
    <NarrowWrapper>
      <FormBorrowBlocked />
    </NarrowWrapper>
  )
}

export const routeBorrow = createRoute({
  headerTitle: 'Borrow',
  layoutType: 'narrow-extended',
  component: RouteBorrow,
  checkConnect: true,
})
